import React from "react";
import styles from "./Pages_Coming_Soon.module.css";
import comingSoon from "../../../assets/images/comingSoon.svg";

const Pages_Coming_Soon = () => {
  return (
    <div className={styles.comingSoonContainer}>
      <div className={styles.comingSoonCard}>
        {/* Image placeholder */}
        <div className={styles.imagePlaceholder}>
          <div className={styles.placeholderContent}>
            <img src={comingSoon} alt="" />
          </div>
        </div>

        {/* Coming Soon Title */}
        <h1 className={styles.comingSoonTitle}>Coming Soon</h1>

        {/* Description */}
        <p className={styles.comingSoonDescription}>
          Connect with us for exclusive updates and beta invites
        </p>

        {/* Subscribe Button */}
        {/* <button className={styles.subscribeButton}>Join Waitlist Now</button> */}
      </div>
    </div>
  );
};

export default Pages_Coming_Soon;
